import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=05307115&scoped=true&"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts&"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts&"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=05307115&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05307115",
  null
  
)

export default component.exports